import { paths, newSearchParams } from 'src/routes/paths';
import { usePathname, useSearchParams } from 'src/routes/hooks';

import { CONFIG } from 'src/global-config';
import { useTranslate } from 'src/locales';

// ----------------------------------------------------------------------

export function useRedirectToSignIn() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const { currentLang } = useTranslate();

  const returnTo = `${pathname}${newSearchParams({ ...Object.fromEntries(searchParams), country: currentLang.countryName })}`;

  return `${paths.auth[CONFIG.auth.method].signIn}${newSearchParams({
    country: currentLang.countryName,
    returnTo,
  })}`;
}
